export default () => {
    if(process.env.NODE_ENV === 'development'){
        return 'http://localhost:3006/api';
    } else {
        return 'https://adminwoj.tomada.usermd.net/api';
    }
}
